import { Anchor as PopoverAnchor } from '@radix-ui/react-popover';
import { useRef, useState } from 'react';
import { BaseCell } from 'src/components/TableV2/cells';
import { Popover, Stack } from 'src/core/ui';

import * as styles from './RetailTableComponents.css';
import { SalePill } from './SalePill';
import { SaleSearchPopover } from './SaleSearchPopover';

function PillsList({
  salesGroupIds,
  onOpen,
  hasOverflow,
}: {
  salesGroupIds: string[];
  onOpen: (salesGroupId: string) => void;
  hasOverflow: boolean;
}) {
  return (
    <div className={hasOverflow ? styles.pillsOverflow : undefined}>
      <Stack gap="s">
        {salesGroupIds.map((groupId) => (
          <SalePill
            key={groupId}
            label={groupId.slice(0, 8)}
            isGroup
            onOpen={() => onOpen(groupId)}
          />
        ))}
      </Stack>
    </div>
  );
}

export function UnpaidSalesCell({
  salesGroupIds,
  onOpenSalesGroup,
}: {
  salesGroupIds: string[];
  onOpenSalesGroup: (salesGroupId: string) => void;
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const anchorRef = useRef<HTMLDivElement>(null);

  const hasOverflow = salesGroupIds.length > 2;

  if (!hasOverflow) {
    return (
      <BaseCell style={{ minWidth: 0, padding: 0 }}>
        <Stack
          justifyContent="spaceBetween"
          alignItems="center"
          className={styles.cellLayout}
        >
          <PillsList
            salesGroupIds={salesGroupIds}
            onOpen={onOpenSalesGroup}
            hasOverflow={false}
          />
        </Stack>
      </BaseCell>
    );
  }

  return (
    <Popover.Root onOpenChange={(open) => !open && setSearchQuery('')}>
      <BaseCell style={{ minWidth: 0, padding: 0 }}>
        <PopoverAnchor asChild>
          <Stack
            ref={anchorRef}
            justifyContent="spaceBetween"
            alignItems="center"
            className={styles.cellLayout}
          >
            <PillsList
              salesGroupIds={salesGroupIds}
              onOpen={onOpenSalesGroup}
              hasOverflow
            />
            <SaleSearchPopover
              salesGroupIds={salesGroupIds}
              onOpenSalesGroup={onOpenSalesGroup}
              searchQuery={searchQuery}
              onSearchQueryChange={setSearchQuery}
              anchorRef={anchorRef}
            />
          </Stack>
        </PopoverAnchor>
      </BaseCell>
    </Popover.Root>
  );
}
